import config from '../../../../../../../../config'

import { LOAD_GROUPS, LOAD_GROUPS_REQUEST, GROUPS_LOADED } from './constants'

export function loadGroups() {
    return {
        type: LOAD_GROUPS,
    }
}

export function loadGroupsRequest() {
    return {
        type: LOAD_GROUPS_REQUEST,
        payload: {
            ...config.api.entityStack.groups.get,
        },
    }
}

export function groupsLoaded(groups) {
    return {
        type: GROUPS_LOADED,
        data: {
            groups,
        },
    }
}
